'use client'

import Contact from '@/app/contact/_components/Contact'
import { useScrollTracking } from '@/hooks/useScrollTracking'

const ContactPage = () => {
  useScrollTracking()
  
  return <Contact />
}

export default ContactPage
